import { lazy, Suspense } from 'react'
import LazyMount from '../ui/LazyMount'
import { useHomepage } from '../../context/HomepageContext'

const WelcomeSection = lazy(() => import('./WelcomeSection'))
const AboutSection = lazy(() => import('./AboutSection'))
const ExcellenceSection = lazy(() => import('./ExcellenceSection'))
const ProgramsSection = lazy(() => import('./ProgramsSection'))
const VisionMissionSection = lazy(() => import('./VisionMissionSection'))
const FindProgramSection = lazy(() => import('./FindProgramSection'))
const SupportCardsSection = lazy(() => import('./SupportCardsSection'))
const MayarNumbersSection = lazy(() => import('./MayarNumbersSection'))
const NewsSection = lazy(() => import('./NewsSection'))
const EventsSection = lazy(() => import('./EventsSection'))
const FacilitiesSection = lazy(() => import('./FacilitiesSection'))

const SECTION_COMPONENTS = {
  welcome: WelcomeSection,
  about: AboutSection,
  excellence: ExcellenceSection,
  programs: ProgramsSection,
  vision_mission: VisionMissionSection,
  find_program: FindProgramSection,
  support_cards: SupportCardsSection,
  mayar_numbers: MayarNumbersSection,
  news: NewsSection,
  events: EventsSection,
  facilities: FacilitiesSection,
}

const HIDDEN_SECTIONS = new Set(['potential', 'continue_journey', 'hero_stats'])

const DEFAULT_ORDER = [
  'welcome',
  'about',
  'excellence',
  'programs',
  'find_program',
  'support_cards',
  'mayar_numbers',
  'news',
  'events',
  'facilities',
]

const EAGER_SECTION_COUNT = 2

export default function HomeSections() {
  const { sections, loaded } = useHomepage()

  const orderedSections = loaded && Object.keys(sections).length
    ? Object.values(sections)
        .filter((section) => !HIDDEN_SECTIONS.has(section.key) && section.is_active !== false)
        .sort((a, b) => (a.sort_order ?? 0) - (b.sort_order ?? 0))
    : DEFAULT_ORDER.map((key, index) => ({ key, sort_order: index + 1, is_active: true }))

  return (
    <>
      {orderedSections.map((section, index) => {
        const Component = SECTION_COMPONENTS[section.key]
        if (!Component) return null

        const content = (
          <Suspense fallback={null}>
            <Component />
          </Suspense>
        )

        if (index < EAGER_SECTION_COUNT) {
          return <div key={section.key}>{content}</div>
        }

        return (
          <LazyMount key={section.key}>
            {content}
          </LazyMount>
        )
      })}
    </>
  )
}
